import React, { Component } from "react";
import { Spin, Form, Row, Col, Upload, Switch, Radio, message , Divider} from "antd";
import { PictureOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import {
  FormItem,
  ErrorItem,
  ButtonItem,
} from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import RichTextEditor from "../../../../Components/RichTextEditor";
import axios from "axios"

function getBase64(file) { // Convierte un archivo a base64 para previsualización y envío
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const urlImagenFija = process.env.NODE_ENV === "development" ? `http://localhost:3001/Apariencia/login/Bienvenida-Banner-Biwo.png` :  "https://biwo.online/Apariencia/login/Bienvenida-Banner-Biwo.png";
const urlVideoFijo = process.env.NODE_ENV === "development" ? `http://localhost:3001/Apariencia/login/Bienvenida-Video-Login.mp4` :  "https://biwo.online/Apariencia/login/Bienvenida-Video-Login.mp4";

class AparienciaLogin extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    formConCambios: false,
    tipoMedia: "imagen",
    previewUrl: null,
    videoPreviewUrl: null,
  };

  componentDidMount() {
    this.consultarConfiguracion();
  }

  consultarConfiguracion = async () => {
    this.setState({ loading: true });
    try {
      const response = await axios.post(
        "configuracionBiwoApariencia/obtenerConfiguracionLogin",
        {},
        { headers: this.props.headersToken }
      );
      const data = response.data || {};
      const tipoMedia = data.tipoMedia || "imagen";
      this.formRef.current.setFieldsValue({
        mostrarGlass: data.mostrarGlass ?? true,
        textoGlass: data.textoGlass || "",
        tipoMedia,
      });
      this.setState({
        tipoMedia,
        previewUrl: urlImagenFija + "?t=" + Date.now(),
        videoPreviewUrl: data.tieneVideo ? urlVideoFijo + "?t=" + Date.now() : null,
      });

    } catch (error) {
      console.error("Error al consultar la config:", error);
      message.warning("No se pudo cargar la configuración previa del servidor.");
    } finally {
      this.setState({ loading: false, formConCambios: false });
    }
  };

  onFinish = async (values) => {
    this.setState({ loading: true });

    try {
      const esArchivo = (fileItem) =>
        fileItem?.originFileObj instanceof Blob ||
        fileItem?.originFileObj instanceof File;

      const tipoMedia = values.tipoMedia || "imagen";

      // El archivo (imagen/video) viaja como multipart/form-data, no como base64.
      const form = new FormData();
      form.append("textoGlass", values.textoGlass || "");
      form.append("mostrarGlass", values.mostrarGlass ?? true);
      form.append("tipoMedia", tipoMedia);

      let subioImagen = false;
      let subioVideo = false;

      if (values.imagenLogin && values.imagenLogin.length > 0) {
        const fileItem = values.imagenLogin[0];
        if (esArchivo(fileItem)) {
          form.append("imagen", fileItem.originFileObj);
          subioImagen = true;
        }
      }

      if (values.videoLogin && values.videoLogin.length > 0) {
        const fileItem = values.videoLogin[0];
        if (esArchivo(fileItem)) {
          form.append("video", fileItem.originFileObj);
          subioVideo = true;
        }
      }

      const response = await axios.post(
        "configuracionBiwoApariencia/actualizarConfiguracionLogin",
        form,
        { headers: this.props.headersToken }
      );

      if (response.data && response.data.success === 1) {
        message.success("Configuración guardada exitosamente");

        // Si se subió archivo nuevo, conservar el preview ya visible.
        // Si no, refrescar desde el servidor con cache buster.
        this.setState((prev) => ({
          formConCambios: false,
          tipoMedia,
          previewUrl: subioImagen
            ? prev.previewUrl
            : urlImagenFija + "?t=" + Date.now(),
          videoPreviewUrl: subioVideo
            ? prev.videoPreviewUrl
            : prev.videoPreviewUrl,
        }));

        return true;
      } else {
        // Si el backend mandó success: 0
        message.error(response.data.message || "Error al guardar la configuración");
        return false;
      }

    } catch (error) {
      console.error("Error en la petición POST:", error);
      message.error("Error de conexión al intentar guardar los datos.");
      return false;
    } finally {
      this.setState({ loading: false });
    }
  };

  onFinishFailed = (e) => {
    ErrorItem(e);
  };

  normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList;
  };

  beforeUpload = (file) => { // Validaciones antes de aceptar el archivo y generar preview
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Solo se permiten imágenes");
      return Upload.LIST_IGNORE;
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("La imagen debe pesar menos de 5MB");
      return Upload.LIST_IGNORE;
    }
    // Generar preview
    getBase64(file).then((url) => this.setState({ previewUrl: url }));
    return false; // evitar upload automático
  };

  beforeUploadVideo = (file) => { // Validaciones del video y preview local
    const isMp4 = file.type === "video/mp4";
    if (!isMp4) {
      message.error("Solo se permiten videos MP4");
      return Upload.LIST_IGNORE;
    }
    const isLt20M = file.size / 1024 / 1024 < 20;
    if (!isLt20M) {
      message.error("El video debe pesar menos de 20MB");
      return Upload.LIST_IGNORE;
    }
    // Preview local sin cargar todo el archivo en memoria (object URL)
    this.setState({ videoPreviewUrl: URL.createObjectURL(file) });
    return false; // evitar upload automático
  };

  handleValuesChange = (changed) => {
    if (!this.state.formConCambios) this.setState({ formConCambios: true });
    if (changed.tipoMedia) this.setState({ tipoMedia: changed.tipoMedia });
  };

  // Métodos expuestos al padre (AparienciasBiwo)
  tieneCambios = () => this.state.formConCambios;

  guardarDesdePadre = () => {
    return this.formRef.current
      .validateFields()
      .then((values) => this.onFinish(values))
      .catch(() => false);
  };

  descartarCambios = () => {
    this.setState({ formConCambios: false });
    this.consultarConfiguracion();
  };

  render() {
    const { loading, previewUrl, videoPreviewUrl, tipoMedia } = this.state;

    return (
      <Spin spinning={loading}>
        <Form
          name="aparienciaLogin"
          layout="vertical"
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
          ref={this.formRef}
          onValuesChange={this.handleValuesChange}
          initialValues={{
            mostrarGlass: true,
            tipoMedia: "imagen",
            textoGlass:
              "Transforma cada desafío en una oportunidad con nuestro ERP: organiza, optimiza y avanza hacia el éxito con confianza",
          }}
        >
          <Row gutter={24}>

            {/* imagen o video */}
            <Col xs={24} sm={24} md={10}>
              <DynamicCardForm
                title="Fondo del Login"
                style={{ margin: "0 auto 12px auto", maxWidth: "98%" }}
              >
                <FormItem
                  label="Tipo de fondo"
                  name="tipoMedia"
                  tooltip="Elige si el lado izquierdo del login muestra una imagen o un video en loop."
                >
                  <Radio.Group buttonStyle="solid">
                    <Radio.Button
                      value="imagen"
                      style={{
                        borderRadius: "8px 0 0 8px",
                        ...(tipoMedia === "imagen" && {
                          backgroundColor: "#00BFD6",
                          borderColor: "#00BFD6",
                        }),
                      }}
                    >
                      Imagen
                    </Radio.Button>
                    <Radio.Button
                      value="video"
                      style={{
                        borderRadius: "0 8px 8px 0",
                        ...(tipoMedia === "video" && {
                          backgroundColor: "#00BFD6",
                          borderColor: "#00BFD6",
                        }),
                      }}
                    >
                      Video
                    </Radio.Button>
                  </Radio.Group>
                </FormItem>

                {tipoMedia === "video" ? (
                  <>
                    <FormItem
                      label="Video de fondo"
                      name="videoLogin"
                      valuePropName="fileList"
                      getValueFromEvent={this.normFile}
                      tooltip="Video MP4 (máx 20MB). Se reproduce en loop, sin sonido."
                    >
                      <Upload
                        name="videoLoginFile"
                        listType="picture-card"
                        maxCount={1}
                        beforeUpload={this.beforeUploadVideo}
                        accept="video/mp4"
                        style={{ width: "100%" }}
                      >
                        <div>
                          <VideoCameraOutlined />
                          <div style={{ marginTop: 8 }}>Subir video</div>
                        </div>
                      </Upload>
                    </FormItem>

                    {videoPreviewUrl && (
                      <div style={{ marginTop: 8, marginBottom: 12 }}>
                        <p style={{ fontSize: 12, color: "#888", marginBottom: 6 }}>
                          Vista previa:
                        </p>
                        <video
                          src={videoPreviewUrl}
                          autoPlay
                          loop
                          muted
                          playsInline
                          style={{
                            width: "100%",
                            maxHeight: 220,
                            objectFit: "cover",
                            borderRadius: 12,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <FormItem
                      label="Banner lateral"
                      name="imagenLogin"
                      valuePropName="fileList"
                      getValueFromEvent={this.normFile}
                      tooltip="Imagen que aparece en el lado izquierdo de la pantalla de login."
                    >
                      <Upload
                        name="imagenLoginFile"
                        listType="picture-card"
                        maxCount={1}
                        beforeUpload={this.beforeUpload}
                        accept="image/*"
                        style={{ width: "100%" }}
                      >
                        <div>
                          <PictureOutlined />
                          <div style={{ marginTop: 8 }}>Subir imagen</div>
                        </div>
                      </Upload>
                    </FormItem>

                    {previewUrl && (
                      <div style={{ marginTop: 8, marginBottom: 12 }}>
                        <p style={{ fontSize: 12, color: "#888", marginBottom: 6 }}>
                          Vista previa:
                        </p>
                        <img
                          src={previewUrl}
                          alt="Preview login"
                          style={{
                            width: "100%",
                            maxHeight: 220,
                            objectFit: "cover",
                            borderRadius: 12,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                          }}
                        />
                      </div>
                    )}
                  </>
                )}
              </DynamicCardForm>
            </Col>

            {/*  texto de la card */}
            <Col xs={24} sm={24} md={14}>
              <DynamicCardForm
                title="Texto de la Card"
                style={{ margin: "0 auto 12px auto", maxWidth: "98%", overflow: "visible" }}
                bodyStyle={{ paddingBottom: 52 }}
              >
                <FormItem
                  label="Mostrar card de texto"
                  name="mostrarGlass"
                  valuePropName="checked"
                  tooltip="Activa o desactiva la card con el texto sobre la imagen."
                >
                  <Switch />
                </FormItem>

                <FormItem
                  label="Texto de la card"
                  name="textoGlass"
                  tooltip="Texto que aparece sobre la imagen del login en la card con efecto cristal."
                >
                  <RichTextEditor
                    placeholder="Escribe el mensaje de bienvenida..."
                    height={180}
                  />
                </FormItem>

              </DynamicCardForm>
            </Col>
          </Row>

          <Divider style={{ color: "#dbdbdb" }} />

          <ButtonItem
            type="primary"
            htmlType="submit"
            style={{ display: "block", margin: "0 0 0 auto" }}
          >
            Guardar Configuración
          </ButtonItem>
        </Form>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  AparienciaLogin
);
